<h2 mat-dialog-title>Confirm Avatar Parts</h2>
<div mat-dialog-content>
  @for (part of data.parts; track part) {
    <div class="part-row">
      <img [src]="getPartUrl(part)" width="32" />
      <app-user-economy [amount]="part.price"></app-user-economy>
    </div>
  }
  <div class="total-row">
    Total
    <app-user-economy [amount]="totalPrice"></app-user-economy>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button [appThemedButton]="data.theme" [mat-dialog-close]="true">Buy</button>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
</div>
